
define('text!presentation/common/dateTimePicker/views/dateTimePicker.html',[],function () { return '<div class="datetime-picker-container" data-bind="dateTimePickerUI: {dateValue: dateValue, timeValue: timeValue}">\n    <input type="text" class="date-part" data-bind="value: dateValue" />\n    <input type="text" class="time-part" data-bind="value: timeValue" />\n</div>\n';});

